// import getWebEngageId from "./getWebEngageId";
import { store } from "@root/store";
import Router from "@src/lib/router";
import { track } from "cosmos";
import { gtmTrackEvents } from "./trackGtmEvents";

export function newWebEngage(MAIN_ACTION = "", properties = {}) {
  let storeState = store.getState();

  const userDetails =
    storeState?.overviewReducer?.userDetails?.responseData?.user;

  // console.log("&&&&&userDetails", userDetails);

  const orgDetails = storeState?.persistedDataReducer?.orgDetails?.organization;

  let courseId =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData?.id ||
    Router.query.courseId;

  let deviceType = storeState?.persistedDataReducer?.deviceType;
  let isuserideven = userDetails?.id % 2 == 0 ? true : false;
  let isactivesubscriber =
    storeState?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased;
  // console.log(Router?.query?.courseId, Router,'router');
  // alert(JSON.stringify(Router.query.courseId));
  let LAST_ACTION = window.LAST_ACTION;
  window.LAST_ACTION = properties.action;
  const commonProperties = {
    org_id: Number(orgDetails?.id),
    org_code: `${orgDetails?.code}`,
    user_type: 1,
    cp_user_id: Number(userDetails?.id),
    is_user_id_even: Number(userDetails?.id) % 2 == 0 ? true : false,
    user_name: userDetails?.name ? `${userDetails?.name}` : `anonymous`,
    course_id: Number(courseId || Router.query.courseId),
    cp_sdk_source: deviceType != "IOS" ? "android" : "ios",
    is_active_subscriber: isactivesubscriber ? true : false,
    last_action: LAST_ACTION,
    screen_name: "course",
  };

  //   if (!MAIN_ACTION) {
  //     return;
  //   }
  // if (import.meta.env.VITE_ENV !== "STAGING") {

  console.log(
    "Events",
    MAIN_ACTION,
    JSON.parse(
      JSON.stringify({
        ...properties,
        ...commonProperties,
      })
    )
  );
  // }
  //  process.env.NODE_ENV === "production" &&
  // typeof window !== "undefined" &&
  //   window?.webengage?.track(MAIN_ACTION, {
  //     ...properties,
  //     ...commonProperties,
  //   });

  track(MAIN_ACTION, {
    ...properties,
    ...commonProperties,
  });

  gtmTrackEvents(MAIN_ACTION, {
    ...properties,
    ...commonProperties,
  });
}

// export function initWebEngage(user) {
//   if (user && window) {
//     // return;
//     // console.log("****webengageuser", user);
//     window.webEngageMap?.push({ isEventTracked: 1 });
//     window.webengage?.user?.login(user.id);
//     window.webengage?.user?.setAttribute("first_name", user.name || "");
//     window.webengage?.user?.setAttribute("email", user.email || "");
//     window.webengage?.user?.setAttribute("phone", "+" + user.mobile);
//     window.webengage?.user?.setAttribute("platform", "+" + "WEB");
//   }
// }

// export function webengageString() {
//   return `
//     var webengage;
//     !(function (w, e, b, n, g) {
//       function o(e, t) {
//         e[t[t.length - 1]] = function () {
//           r.__queue.push([t.join("."), arguments]);
//         };
//       }
//       var i,
//         s,
//         r = w[b],
//         z = " ",
//         l = "init options track screen onReady".split(z),
//         a = "feedback survey notification".split(z),
//         c = "options render clear abort".split(z),
//         p = "Open Close Submit Complete View Click".split(z),
//         u = "identify login logout setAttribute".split(z);
//       if (!r || !r.__v) {
//         for (
//           w[b] = r = { __queue: [], __v: "6.0", user: {} }, i = 0;
//           i < l.length;
//           i++
//         )
//           o(r, [l[i]]);
//         for (i = 0; i < a.length; i++) {
//           for (r[a[i]] = {}, s = 0; s < c.length; s++) o(r[a[i]], [a[i], c[s]]);
//           for (s = 0; s < p.length; s++) o(r[a[i]], [a[i], "on" + p[s]]);
//         }
//         for (i = 0; i < u.length; i++) o(r.user, ["user", u[i]]);
//         setTimeout(function () {
//           var f = e.createElement("script"),
//             d = e.getElementById("_webengage_script_tag");
//           (f.type = "text/javascript"),
//             (f.async = !0),
//             (f.src =
//               ("https:" == e.location.protocol
//                 ? "https://ssl.widgets.webengage.com"
//                 : "http://cdn.widgets.webengage.com") +
//               "/js/webengage-min-v-6.0.js"),
//             (f.onload = function () {
//               window?.webengage?.onReady?.(function () {
//                 window?.webEngageReadyEvent?.();
//               });
//             });
//           d.parentNode.insertBefore(f, d);
//         });
//       }
//     })(window, document, "webengage");
//     webengage.init("${getWebEngageId()}");
//   `;
// }
